"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox = void 0;
const React = require("react");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const layout_1 = require("../modules/layout");
const theme_1 = require("../modules/theme");
const test_1 = require("../modules/test");
const react_native_1 = require("react-native");
class CheckBox extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const { disabled } = this.props;
            const iconSize = (0, layout_1.isTablet)() ? 24 : 20;
            return react_native_1.StyleSheet.create({
                container: {
                    flexDirection: 'row',
                    alignItems: 'center'
                },
                icon: {
                    color: disabled ? theme.disabledColor : theme.textColor1,
                    width: (0, layout_1.isTablet)() ? 28 : 24,
                    fontSize: iconSize,
                    height: iconSize,
                    lineHeight: iconSize
                },
                label: {
                    color: disabled ? theme.disabledColor : theme.textColor1,
                    fontFamily: theme.fontFamily3,
                    fontSize: (0, layout_1.isTablet)() ? 15 : 12,
                    flexShrink: 1
                }
            });
        };
    }
    render() {
        const { label, value, onChange, disabled, style, labelStyle, renderLabel, nativeID } = this.props;
        const styles = this.getStyles();
        return (React.createElement(react_native_1.TouchableOpacity, { style: [styles.container, style], disabled: disabled, onPress: () => {
                if (onChange) {
                    onChange(!value);
                }
            } },
            React.createElement(FontAwesome_1.default, { nativeID: nativeID, testID: (0, test_1.getTestID)(nativeID), name: value ? 'check-square-o' : 'square-o', style: styles.icon }),
            React.createElement(react_native_1.Text, { style: [styles.label, labelStyle] }, renderLabel ? renderLabel() : label)));
    }
}
exports.CheckBox = CheckBox;
